// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__PgarZ","toggleWrap":"styles_toggleWrap__2RJl_","content":"styles_content__4i5h8","selectAreaCode":"styles_selectAreaCode__14na9"};